export const PATIENT_UNIT = {
  BLOOM: 'bloom',
  MOVE: 'move',
  SWORD: 'sword',
  MIND: 'mind',
}
